import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-booking-date-timezone',
    templateUrl: './editor-booking-item-setting-field-booking-date-timezone.component.html',
    standalone: false
})
export class EditorBookingItemSettingFieldBookingDateTimezoneComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  tzNames: { id: string, name: string }[];
  filteredTzNames: Observable<{ id: string, name: string }[]>;
  // timezone: { timezone: string; datetime: string; utcDatetime: Date; zonedDatetime: Date; };

  constructor(private editorData: EditorDataService) {
    this.tzNames = this.editorData.tzNames;
  }

  ngOnInit() {
    this.filteredTzNames = this.parentFormGroup.controls['timezone'].valueChanges.pipe(
      startWith(undefined),
      takeUntil(this.destroyed$),
      map(value => this.filterTzNames(this.tzNames, value))
    );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
/*
  updateTimezone(event) {
    this.timezone = event.detail;
  }
*/
  private filterTzNames(tzNames: { id: string, name: string }[], value: string): { id: string, name: string }[] {
    if (value === undefined) {
      return tzNames;
    }

    const filterValue = value.toUpperCase();
    return tzNames.filter(tzName => tzName.name.toUpperCase().includes(filterValue));
  }

  getFormControl(): FormControl {
    return this.parentFormGroup.controls['timezone'] as FormControl;
  }
}
